import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../store/action/cartAction";
import { ToastContainer, toast } from "react-toastify";
import MobileProducts from "./MobileProducts";
import { IoCaretBack, IoCaretForward } from "react-icons/io5";
import PostHog from "posthog-js";
import "react-toastify/dist/ReactToastify.css";
import "./home.css";
import "./style.css";

const serverUrl = process.env.REACT_APP_SERVER_URL;

function Products({
  products,
  searchTerm,
  loading,
  onClose,
  error,
  activeCategory,
  setActiveCategory,
  setSearchTerm,
  currentPage,
  setCurrentPage,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [itemsPerPage] = useState(8);

  const [catandtag, setCatAndTag] = useState({ data: [] });

  useEffect(() => {
    const fetchTaxonomies = async () => {
      try {
        const response = await fetch(`${serverUrl}/api/taxonomies`);
        if (!response.ok) throw new Error("Failed to fetch taxonomies");
        const data = await response.json();
        setCatAndTag({ data });
      } catch (err) {
        setCatAndTag({ data: [] });
        console.error("Error fetching taxonomies:", err);
      }
    };
    fetchTaxonomies();
  }, []);

  const categories = [
    "All",
    ...(catandtag.data || [])
      .filter((item) => item.type === "category")
      .map((category) => category.name),
  ];

  const tabBoxRef = useRef(null);
  const productListRef = useRef(null);

  useEffect(() => {
    if (productListRef) {
      productListRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentPage]);

  // Optional: Add scroll arrows logic if needed
  const scroll = (direction) => {
    if (tabBoxRef.current) {
      tabBoxRef.current.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth",
      });
    }
  };

  // Reset to first page when filters change
  // useEffect(() => {
  //   if (currentPage !== 1) {
  //     setCurrentPage(1);
  //   }
  // }, [activeCategory, searchTerm]);

  const filterProducts = (products, activeCategory, searchTerm) => {
    if (!products?.products) return [];
    const normalizedSearch = searchTerm.toLowerCase();

    // Find all products that match the name
    const nameMatches = products.products.filter(
      (product) =>
        (product.item_name &&
          product.item_name.toLowerCase() === normalizedSearch) ||
        (product.title && product.title.toLowerCase() === normalizedSearch)
    );

    // Find other products in the same category or tag, excluding name matches
    const similarProducts = products.products.filter((product) => {
      const matchesCategory =
        activeCategory === "All" ||
        product.category === activeCategory ||
        product.tag === activeCategory;
      const isNameMatch =
        (product.item_name &&
          product.item_name.toLowerCase() === normalizedSearch) ||
        (product.title && product.title.toLowerCase() === normalizedSearch);
      return matchesCategory && !isNameMatch;
    });

    return [...nameMatches, ...similarProducts];
  };

  const filteredProducts = filterProducts(products, activeCategory, searchTerm);
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentProducts = filteredProducts.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleProductClick = (product) => {
    // Track the product click event using posthog
    PostHog.capture("Product Click", {
      property: "Product Name",
      value: product.item_name,
    });

    // Navigate to the product details page
    navigate(`/ProductDetails/${product.id}`, {
      state: {
        product,
        fromProducts: true,
        page: currentPage,
        category: activeCategory,
      },
    });
  };

  const handleAddToCart = (product) => {
    try {
      dispatch(addToCart(product));
      toast.success("Successfully added to cart 🥳");

      // Track the "Add to Cart" event
      PostHog.capture("Add to Cart", {
        property: "Product Name",
        value: product.item_name,
      });
      PostHog.capture("Add to Cart", {
        property: "Product Price",
        value: product.price,
      });
    } catch (error) {
      toast.error("Error adding to cart:", error.message);
    }
  };

  const PaginationControls = () => (
    <div className="pagination-controls">
      <button
        onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
        disabled={currentPage === 1}
      >
        Previous
      </button>

      <span>
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );

  if (loading) {
    return (
      <section id="product0" className="loading">
        <div className="container1">
          <div className="content-box" id="product-list">
            {Array.from({ length: 8 }).map((_, index) => (
              <div className="products skeleton" key={index}>
                <div className="item">
                  <div className="image-container skeleton-box"></div>
                  <h2 className="skeleton-box skeleton-text">Loading...</h2>
                  <div className="price skeleton-box skeleton-text"></div>
                  <div className="cart-condition">
                    <div className="condition skeleton-box skeleton-text"></div>
                    <button className="addCart skeleton-box skeleton-button"></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="product0">
      <div className="container1">
        {" "}
        <button className="close-button-back" onClick={onClose}>
          <span className="button-icon">
            <IoCaretBack />
          </span>
          <span className="button-text">Back to High Lights</span>
        </button>
        <div className="tab-container">
          {/* Left Arrow */}
          <button
            className="scroll-arrow left-arrow"
            onClick={() => scroll("left")}
          >
            <IoCaretBack />
          </button>

          {/* Category Tabs */}
          <div className="tab_box" ref={tabBoxRef}>
            {categories.map((category) => (
              <button
                key={category}
                className={`tab_btn ${
                  activeCategory === category ? "active" : ""
                }`}
                onClick={() => {
                  setActiveCategory(category);
                  setSearchTerm("");
                }}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Right Arrow */}
          <button
            className="scroll-arrow right-arrow"
            onClick={() => scroll("right")}
          >
            <IoCaretForward />
          </button>
        </div>
        <div id="app"></div>
        <div id="temporaryContent" ref={productListRef}>
          <div className="content-box" id="product-list">
            {
              currentProducts.length > 0
                ? currentProducts.map((product) => (
                    <div className="products" key={product.id}>
                      <div className="item" key={product.id}>
                        <div className="image-container">
                          <img
                            src={
                              Array.isArray(product.itemPhotos) &&
                              product.itemPhotos.length > 0
                                ? product.itemPhotos[0]
                                : "/media/no_product.95b9d3f53bac1fe117d8.png"
                            }
                            alt={product.item_name}
                            onClick={() => handleProductClick(product)}
                          />
                        </div>
                        <h2>{product.item_name}</h2>
                        <div className="price">K {product.price}</div>
                        <div className="cart-condition">
                          <div className="condition">
                            <span>{product.condition}</span>
                          </div>
                          <button
                            className={`addCart ${
                              !product.available ? "disabled" : ""
                            }`}
                            disabled={!product.available}
                          >
                            <span>
                              <svg
                                onClick={() => handleAddToCart(product)}
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 20"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M6 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0h8m-8 0-1-4m9 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-9-4h10l2-7H3m2 7L3 4m0 0-.792-3H1"
                                />
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                : null /* Removed the "no product found" section */
            }
          </div>
          <div className="mobile-products">
            <MobileProducts
              currentProducts={currentProducts}
              handleAddToCart={handleAddToCart}
              currentPage={currentPage}
              activeCategory={activeCategory}
            />
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          {filteredProducts.length > itemsPerPage && <PaginationControls />}
        </div>
      </div>
    </section>
  );
}

export default Products;
